export default {
  YES_OR_NO: 'YES_OR_NO',
  // METER_TYPE: "METER_TYPE",
  // METER_TYPE_SUM : "1",
  // METER_ALLOCATE_STATE: "METER_ALLOCATE_STATE",
  // METER_ALLOCATE_STATE_NO: "0",
  // LESSEE_STATE:'LESSEE_STATE',
  // LESSEE_PRICE_TYPE:'LESSEE_PRICE_TYPE',
  // LESSEE_PRICE_TYPE_COMMON:'1',
  // LESSEE_PRICE_TYPE_USER:'2',
  // ACCOUNT_STREAM_DIR:'ACCOUNT_STREAM_DIR',
  // ENERGY_BILL_STATE:'ENERGY_BILL_STATE',
  // LESSEE_ALARM_TYPE:'LESSEE_ALARM_TYPE',
  // LESSEE_METER_IS_FEE:'LESSEE_METER_IS_FEE',
  // LESSEE_METER_IS_FEE_YES:'1',
  // LESSEE_METER_IS_FEE_NO:'0',
  // LESSEE_METER_PAY_TYPE:'LESSEE_METER_PAY_TYPE',
  // LESSEE_METER_PAY_TYPE_FIRST:'1',
  // LESSEE_METER_PAY_TYPE_LAST:'2',
  // MONTH_BILL_PAYEE_TYPE:'MONTH_BILL_PAYEE_TYPE',
  // LESSEE_ALARM_STYLE:'LESSEE_ALARM_STYLE',
  METER_TYPE: 'METER_TYPE', //电表制式
  LESSEE_TYPE: 'LESSEE_TYPE', //业态
  PAY_TYPE: 'PAY_TYPE', //付款方式
  ONLINE_OFFLINE: 'ONLINE_OFFLINE', //线上线下
  METER_CONNECT_TYPE: 'METER_CONNECT_TYPE',
  COMMUNICATION_CARD_TYPE: 'COMMUNICATION_CARD_TYPE', //通信卡类型
  COMMUNICATION_CARD_ISP: 'COMMUNICATION_CARD_ISP', //通信卡运营商
  METER_DATA_ALARM_TYPE: 'METER_DATA_ALARM_TYPE', //数据告警类型
  ARREARS_ALARM_TYPE: 'ARREARS_ALARM_TYPE', //欠费告警类型
  SENSOR_TYPE_ELECTRIC_METER: '1', //首页电能耗曲线
  SENSOR_TYPE_WATER_METER: '2', //首页水能耗曲线
  BREAK_AND_ENABLE_GATE_TYPE: 'BREAK_AND_ENABLE_GATE_TYPE', //开合闸类型
  WATER_DATA_ALARM_TYPE: 'WATER_DATA_ALARM_TYPE',
  PAY_ORDER_STATE :"PAY_ORDER_STATE" ,// 订单状态
  PROPERTY_STAFF_WORK_POSITION:"PROPERTY_STAFF_WORK_POSITION", //岗位
};
